import { useState, useEffect } from 'react';

const useSpeechToText = ({ text, setText }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const uploadWavFile = async (file) => {
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(
        'https://dewa-uaen-prd-rammas-appsvc-bot-fva0avabh8hkana5.uaenorth-01.azurewebsites.net/api/stt',
        {
          method: 'POST',
          body: formData,
          headers:{
            'X-File-Type': 'wav',
          }
        }
      );

      const result = await response.json();

      if (response.ok) {
        setText(result.text); // Update recognizedText here
      } else {
        setError(result.error || 'Unknown error occurred');
      }
    } catch (err) {
      setError('Error uploading file');
    } finally {
      setLoading(false);
    }
  };

  // Adding useEffect to track recognizedText changes


  return { error, loading, uploadWavFile };
};

export default useSpeechToText;
